module.exports = "https://static.energy5.com/_next/static/images/instagram-15a0fd7f6d9d3b80f2caa7a740978b6f.png";